import { MainStateService } from './../common/main-state.service';
import { takeUntil } from 'rxjs/operators';
import { VideoPlayerService } from './components/videos/video-player-window/video-player.service';
import { AfterViewInit, ChangeDetectorRef, Component, ComponentRef, ElementRef, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { MatTabGroup } from '@angular/material/tabs';
import { Point } from '@core_n/common/Point';
import { ZIndexMngr } from '@core_n/common/ZIndexMngr';
import { MsgBoxService } from '@core_n/msg-boxes/msg-box.service';
import { AnalyticsMngrService } from '@core_n/msg/analytics-mngr.service';
import { SoundMsgMngrService } from '@core_n/msg/sound-msg-mngr.service';
import { VideoMsgMngrService } from '@core_n/msg/video-mngr.service';
import { Subject } from 'rxjs';
import { AroSensorComponent } from '../../../app/aro/aro-sensor.component';
import { SensorObject } from '../../../app/asp/SensorObject';
import * as projEnums from '../../../app/common/projEnums';
import * as projMsgs from '../../../app/msg/projMsgs';
import * as aspObjects from '../asp/aspObjects';
import * as aspSettings from '../asp/aspSettings';
import { mainMapMngr } from '../asp/MapMngr';
import { SensorCoreObject } from '../asp/SensorCoreObject';
import * as consts from '../common/consts';
import * as enums from '../common/enums';
import { IAro } from '../common/inject';
import * as settings from '../common/settings';
import * as units from '../common/units';
import * as utils from '../common/utils';
import { AroSensorTabDetailsComponent } from './../../../app/aro/aro-sensor-tab-details.component';
import { AlertPolygonObject } from './../alert-polygon/alert-polygon.component';
import { Animations } from './../Animations';
import * as aro from './aro';
import { AroService } from './aro.service';
import { CoordsComponent } from './components/coords/coords.component';
import { FieldWriteNumberComponent } from './fields/field-write-number.component';

@Component({
  templateUrl: './aro-sensor-core.component.html',
  styleUrls: ['./aro.component.scss'],
  animations: [
    Animations.BlinkRedError,
    Animations.WindowOpenCloseFadeHeight
  ]
})
export class AroSensorCoreComponent extends ZIndexMngr implements IAro, OnInit, AfterViewInit {
  @ViewChild('tabGroup') public tabGroup: MatTabGroup;
  @ViewChild('tab2Container', { read: ViewContainerRef }) protected tab2Container: ViewContainerRef;
  @ViewChild('MinCoverageAng') public MinCoverageAng: FieldWriteNumberComponent;
  @ViewChild('MaxCoverageAng') public MaxCoverageAng: FieldWriteNumberComponent;
  @ViewChild('coords') coords: CoordsComponent;

  // Main data
  public sensor: SensorCoreObject = null;
  public sliderState: boolean;
  public disablePlayBtn: boolean = false;
  private _unsubscribeAll$ = new Subject();

  // Properties
  public locUnits: string;
  public shown: boolean = false;

  //Members here
  public sensorId: number = 0;
  public sensorSymbol: string = "";
  public sic: number = 0;
  public sac: number = 0;
  public time: string = "";
  public SensorType: string = "";
  public naiNatArray: any;
  public title: string = "";

  // Position
  public location: string;
  public altitude: string;
  public altitudeUnits: string;
  public natiRtsp: string = "";
  public isAddCamera: boolean = false;
  // Extra
  public identityColor: string;
  public sensorSym: string;

  //Tab Management
  protected tab2ComponentRef: ComponentRef<any>;
  protected tab3ComponentRef: ComponentRef<any>;
  protected tab4ComponentRef: ComponentRef<any>;
  public tab1Label: string = "Overview";
  public tab2Label: string = "Details";
  public tab3Label: string;
  public tab4Label: string;

  // Credibility
  public credForm: FormGroup;

  // animations controls
  public state: boolean = false;

  // all sys and user vals... and animation stuff
  public shortCredUser: number;
  public shortCredSys: number;
  public editModeShort: boolean = false;
  public activeAnimErrShort: boolean = false;
  public blinkAnimErrShort: boolean = false;

  public medCredUser: number;
  public medCredSys: number;
  public editModeMed: boolean = false;
  public activeAnimErrMed: boolean = false;
  public blinkAnimErrMed: boolean = false;

  public longCredUser: number;
  public longCredSys: number;
  public editModeLong: boolean = false;
  public activeAnimErrLong: boolean = false;
  public blinkAnimErrLong: boolean = false;

  credValid = [Validators.required, Validators.max(settings.MAXRADARCREDIBILITY), Validators.min(settings.MINRADARCREDIBILITY), Validators.maxLength(5)];

  // accordion stuff
  public panelOpenState: boolean = false;

  // drawing stuff

  // tool status
  isActiveTool: boolean = false;

  // editing shape color
  private currentColor: string;

  // latest press and latest shape created
  public latestCred: CredType;
  public latestShp: projEnums.GeometricShape;

  // all creds
  public creds: Credibility[] = Array<Credibility>(3);

  // video stuff
  public streamName: string = "";
  
  constructor(
    private aroService: AroService,
    private cdref: ChangeDetectorRef,
    elementRef: ElementRef,
    public dialogRef: MatDialogRef<AroSensorComponent>,
    private fb: FormBuilder,
    protected msgBox: MsgBoxService,
    protected soundService: SoundMsgMngrService,
    protected videoService: VideoPlayerService,
    public analyticsMngrService: AnalyticsMngrService,
    protected videomngr: VideoMsgMngrService,
    protected mainStateService: MainStateService
    ) {
    super(elementRef);
    
    if (settings.userSettings.userPerm == enums.Permission.USER)
      this.ngOnDestroy();

    for (let index = 0; index < this.creds.length; index++) {
      this.creds[index] = new Credibility();
    }

    let self = this;
    this.locUnits = enums.CoordinateTypeTitle(settings.userSettings.coordinatesType);
    setInterval(function () { self.refresh() }, consts.DIALOG_REFRESH_INTERVAL);
  }
 
  ngOnInit(): void {
    this.mainStateService.splitScreenToggleClick$.pipe(takeUntil(this._unsubscribeAll$)).subscribe(isSplitScreen => this.disablePlayBtn = isSplitScreen);
    if ((this.sensor.isNewCamera || this.sensor.isEditCamera) && !settings.userSettings.isCameraAdmin)
      this.ngOnDestroy();

    this.aroService.setSensorAro(this);

    this.credForm = this.fb.group({
      shortCred: [0, this.credValid],
      medCred: [0, this.credValid],
      longCred: [0, this.credValid],
    });
    if (this.sensor)
    {
      this.sliderState = this.sensor.logiConn;

      this.sensor.ObjectUpdate.subscribe(x => {
        this.sliderState = this.sensor.logiConn;
      });

      (this.sensor as SensorObject).showCoverage = true;
      (this.sensor as SensorObject).notifyDataChange();

      if (this.sensor.isEditCamera) {
        try {
          this.videomngr.getCameraRTSP(this.sensor.streamName).toPromise().then(
            (rstpValue) => {
              this.natiRtsp =  rstpValue;
            });   
        }     
        catch(error) {
          console.error(`ERROR getting natiRtsp from wowza API: ${error}`);
        }
      }
  
      if (this.sensor.isNewCamera) {
        this.title = "New Camera";
        this.sensor.handleVid(this.sensor);
        this.identityColor = utils.newmiColorToString(this.sensor.getColor());
        this.sensorSym = this.sensor.getSvgSymbol();
        this.SensorType = this.sensor.SensorType;
        this.sensor.geometry = aspSettings.savedRClickP;
        this.streamName = '';
        this.sensor.streamName = '';
         
      }
      else if (this.sensor.isRadar || this.sensor.isAcoustic) {
        this.title = "Sensor: " + this.sensor.sensorID;
      }
      else if (this.sensor.isVideo) {
        this.title = "Sensor: " + this.sensor.name;
      }
    }
  }

  ngOnDestroy(): void {
    (this.sensor as SensorObject).showCoverage = false;
    (this.sensor as SensorObject).notifyDataChange();
    this.dialogClosed();
    this._unsubscribeAll$.next();
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.windowVisible.next(true);
      if (this.MinCoverageAng)
        this.MinCoverageAng.Form.controls.Field.setValue((this.sensor as SensorObject).AcousticMinAngle);
      if (this.MaxCoverageAng)
        this.MaxCoverageAng.Form.controls.Field.setValue((this.sensor as SensorObject).AcousticMaxAngle);
    });
  }

  protected getTabComponentFactory(tabIndex: number) {
    return null;
  }

  protected refresh(): void {
   
    if (this.sensor != null && !this.sensor.isNewCamera) {
      if (!this.sensor.active()) {
        this.sensor = null;
        this.shown = false;
      }
      else {
        this.updateLocation();
        this.altitude = typeof this.sensor.geometry.z == 'undefined' ? aro.NO_VALUE : units.altitudeValue(this.sensor.geometry.z, true);
        this.altitudeUnits = units.altitudeUnits();
        this.sensorId = this.sensor.sensorID;
        this.sensorSymbol = this.sensor.sensorLetter;
        this.time = this.sensor.datetime;
        this.sic = this.sensor.sic;
        this.sac = this.sensor.sac;
        this.identityColor = utils.newmiColorToString(this.sensor.getColor());
        // this.sensorSym = utils.getPlaneSymbol("acoustic");
        this.sensorSym = this.sensor.getSvgSymbol();

        this.SensorType = this.sensor.SensorType;

        this.naiNatArray = this.sensor.naiNatArray;

        try {
          this.streamName = this.sensor.streamName.split('.')[0];
        }
        catch {
          this.streamName = this.sensor.streamName;
        }

        this.shortCredSys = this.sensor.shortCred;
        this.medCredSys = this.sensor.mediumCred;
        this.longCredSys = this.sensor.longCred;

        if (this.credForm) {

          if (!this.editModeShort) {
            this.credForm.controls.shortCred.setValue(this.sensor.shortCred);
          }

          if (!this.editModeMed) {
            this.credForm.controls.medCred.setValue(this.sensor.mediumCred);
          }

          if (!this.editModeLong) {
            this.credForm.controls.longCred.setValue(this.sensor.longCred);
          }
        }
        // animation triggers and setters
        this.state = !this.state;

        //Dmm Latitude
        if (this.activeAnimErrShort) { this.blinkAnimErrShort = this.state; }
        else { this.blinkAnimErrShort = false; }
        if (this.activeAnimErrMed) { this.blinkAnimErrMed = this.state; }
        else { this.blinkAnimErrMed = false; }
        if (this.activeAnimErrLong) { this.blinkAnimErrLong = this.state; }
        else { this.blinkAnimErrLong = false; }
      }
    }
    else if (this.shown) {
      this.shown = false;
    }
  }

  

  onNatNaiBtnClick(index) {
    this.naiNatArray[index].isVisible = !this.naiNatArray[index].isVisible;
    this.sensor.isNatNaiVisible = true;
    this.sensor.notifyDataChange();
  }

  selectOrRemoveAllNatNai(isChecked) {
    this.naiNatArray.forEach(item => {
      item.isVisible = isChecked;
    });
    this.sensor.isNatNaiVisible = isChecked;
    this.sensor.notifyDataChange();
  }

  async deleteSelectedNatNai() {
    let confirmed = await this.msgBox.showConfirmMsgBox("Are you sure you want to delete the selected Nats and Nais?", "Delete Nat Nai", "Yes", "No");
    if (!confirmed)
      return;


    // let naiNat = new AlertPolygonDialogComponent(null, null, null);
    let len = this.naiNatArray.length;
    for (let i = 0; i < len; i++) {
      if (this.naiNatArray[i].isVisible) {
        // naiNat.deleteNatNai(this.naiNatArray[i].naiNatId, this.sic, this.sac);
        let alertPolygonObj: AlertPolygonObject = new AlertPolygonObject();
        let obj = new projMsgs.Nai();
        alertPolygonObj.Sic = this.naiNatArray[i].sic;
        alertPolygonObj.Sac = this.naiNatArray[i].sac;
        alertPolygonObj.NaiNatId = this.naiNatArray[i].natNaiId;
        alertPolygonObj.OperationAction = projEnums.NatNaiOperationAction.Delete;
        obj.AlertPolygonObj = alertPolygonObj;
        // AppInjector.get(UserActionService).sendUserAction(obj);
      }
    }

    this.sensor.notifyDataChange();
  }

  public showAro(objectId): boolean {
    let sensor = <SensorCoreObject>aspObjects.sensorsPool.getObject(objectId);
    if (!sensor)
      sensor = <SensorCoreObject>aspObjects.sensorTracksPool.getObject(objectId);
    if (sensor) {
      this.sensor = sensor;
      this.shown = true;
      this.tabGroup.realignInkBar();
      this.refresh();
    }
    return sensor != null;
  }

  public hideAro() {
    this.sensor = null;
    this.shown = false;
  }

  public isShown(): boolean {
    return this.shown;
  }

  public getShownId() {
    if (this.sensor == null)
      return null;
    else
      return this.sensor.id;
  }

  updateLocation() {
    if (this.shown && this.sensor && this.sensor.geometry)
      this.location = utils.getCoordinatesString(this.sensor.geometry);
  }

  onCloseBtnClick() {
    this.hideAro();
  }

  locationClick() {
    this.aroService.locationClick();
    this.locUnits = enums.CoordinateTypeTitle(settings.userSettings.coordinatesType);
  }

  onCenterBtnClick() {
    if (this.sensor == null)
      return;
    mainMapMngr.setMapCenter(this.sensor.geometry);
  }

  getID() {
    return this.sensor.id;
  }

  setLocationClick() {
    mainMapMngr.activateMapEventsTool(this.onMapEvent.bind(this), [NeWMI.Map.Enums.EMapEvents.MouseDown]);
  }

  saveCameraClick() {
    if (settings.userSettings.isCameraAdmin) 
    {
          this.sensor.SensorType = this.SensorType;
          this.sensor.status = true;
          let geo: Point = this.coords.readFormLoc();
          this.sensor.geometry.y = geo.y;
          this.sensor.geometry.x = geo.x;
          
          let resMsg = this.videomngr.addUpdateCamera(this.sensor, this.natiRtsp);
          if (resMsg != null)
          {
            this.msgBox.showErrorMsg(resMsg);
            return;
    
          }
          else
          {
            this.sensor.sensorID = resMsg;
            this.sensor.isNewCamera = false;
            this.shown = true;
            this.sensor.notifyDataChange();
            this.dialogClosed();
            this.dialogRef.close();            
          }
    }
  }

  private onMapEvent(evt: NeWMI.Map.Events.MouseEvents) {
    let coord = { x: evt.mapPoint.x, y: evt.mapPoint.y };
    mainMapMngr.activateDefaultTool();
  }

  // Credibility
  onTextChangeShort() {
    // set this to edit mode
    this.editModeShort = true;

    // change value to fit our rules
    let data: number = this.credForm.controls.shortCred.value;
    let str: string = data.toFixed(2);
    if (str.length > 4) {
      str = str.slice(0, 3);
    }

    // set new value
    this.credForm.controls.shortCred.setValue(Number.parseFloat(str));

    // reset animation
    this.activeAnimErrShort = false;
  }

  onCancelEditShort() {
    // set this to read mode
    this.editModeShort = false;
    this.credForm.controls.shortCred.setValue(this.shortCredSys);
  }

  onTextChangeMedium() {
    // set this to edit mode
    this.editModeMed = true;

    // change value to fit our rules
    let data: number = this.credForm.controls.medCred.value;
    let str: string = data.toFixed(2);
    if (str.length > 3) {
      str = str.slice(0, 2);
    }

    // set new value
    this.credForm.controls.medCred.setValue(Number.parseFloat(str));

    // reset animation
    this.activeAnimErrMed = false;
  }

  onCancelEditMedium() {
    // set this to read mode
    this.editModeMed = false;
  }

  onTextChangeLong() {
    // set this to edit mode
    this.editModeLong = true;

    let data: number = this.credForm.controls.longCred.value;
    let str: string = data.toFixed(2);
    if (str.length > 3) {
      str = str.slice(0, 2);
    }

    // set new value
    this.credForm.controls.longCred.setValue(Number.parseFloat(str));

    // reset animation
    this.activeAnimErrLong = false;
  }

  onCancelEditLong() {
    // set this to read mode
    this.editModeLong = false;
  }

  prep2Send(): boolean {
    if (!this.editModeShort && !this.editModeMed && !this.editModeLong) {
      return false;
    }

    if (this.editModeShort) {
      if (!this.credForm.controls.shortCred.valid) {
        this.activeAnimErrShort = true;
        return false;
      }
    }
    if (this.editModeMed) {
      if (!this.credForm.controls.medCred.valid) {
        this.activeAnimErrMed = true;
        return false;
      }
    }
    if (this.editModeLong) {
      if (!this.credForm.controls.longCred.valid) {
        this.activeAnimErrLong = true;
        return false;
      }
    }
    return true;
  }

  numof = 1;
  sendCred() {


    // !!! delete me !!!
    // let vec: AcousticVector = new AcousticVector;
    // vec.ID = this.numof;
    // vec.Lat = 50.99;
    // vec.long = 30.41;
    // vec.date = new Date();
    // (this.sensor as SensorObject).HandleAcousticVector(vec);
    // this.numof++;

    if (!this.prep2Send()) {
      return false;
    }

    if (this.editModeShort) {
      let SetCred = new projMsgs.SetSensor();
      SetCred.Sic = this.sic;
      SetCred.Sac = this.sac;
      SetCred.Credibility = this.credForm.controls.shortCred.value;
      SetCred.CredibilityType = 0;
      // AppInjector.get(UserActionService).sendUserAction(SetCred);

      // reset field state
      this.editModeShort = false;
    }
    if (this.editModeMed) {
      let SetCred = new projMsgs.SetSensor();
      SetCred.Sic = this.sic;
      SetCred.Sac = this.sac;
      SetCred.Credibility = this.credForm.controls.medCred.value;
      SetCred.CredibilityType = 1;
      // AppInjector.get(UserActionService).sendUserAction(SetCred);

      // reset field state
      this.editModeMed = false;
    }
    if (this.editModeLong) {
      let SetCred = new projMsgs.SetSensor();
      SetCred.Sic = this.sic;
      SetCred.Sac = this.sac;
      SetCred.Credibility = this.credForm.controls.longCred.value;
      SetCred.CredibilityType = 2;
      // AppInjector.get(UserActionService).sendUserAction(SetCred);

      // reset field state
      this.editModeLong = false;
    }
  }

  ShowUpdateButt() {
    if ((this.tab2ComponentRef as ComponentRef<AroSensorTabDetailsComponent>))
      return (this.tab2ComponentRef as ComponentRef<AroSensorTabDetailsComponent>).instance.showUpdateButt.length > 0 ? true : false;
    else
      return false;
  }

  CoverageValsChanged() {
    (this.sensor as SensorObject).AcousticMinAngle = this.fixDegrees(this.MinCoverageAng.getValue());
    (this.sensor as SensorObject).AcousticMaxAngle = this.fixDegrees(this.MaxCoverageAng.getValue());
    (this.sensor as SensorObject).updateCoverage();
  }

  fixDegrees(val: number) {
    if (val == undefined)
      return 0;
    while (val < 0)
      val += 360;
    return val;
  }

  OpenSoundWindow() {
    if (this.sensor.isAcoustic)
      this.soundService.openSoundPlayerWindow(this.sensorId, this.streamName);

    if (this.sensor.isVideo && !this.disablePlayBtn)
      this.videoService.showVideoPlayer(this.sensor as any);
  }

  // onAnalyticsClick(event: MatSlideToggleChange) {
  //   this.analyticsMngrService.sendAnalticsRequest(this.sensor.streamName, this.sensor.res, event.checked, this.sensor.workModeType);
  // }

  async changeCameraStatus() {
    if (settings.userSettings.isCameraAdmin && !this.sensor.isNewCamera) 
    {
        let confirmed = await this.msgBox.showConfirmMsgBox("Are you sure you want to change the camera status?", "Camera Status", "Yes", "No");
        if (!confirmed)
          return;

        this.sensor.status = !this.sensor.status;

        this.videomngr.changeCameraStatus(this.sensor.sensorID, this.sensor.status);
    }
  }
}

export enum CredType {
  Short = 0,
  Medium = 1,
  Long = 2
}

export class Credibility {
  Credibility() { }
  public CredTID: string = undefined;
  public CredExist: boolean = false;
  public CredShp: projEnums.GeometricShape = undefined;
  public CredGeo: any = undefined;
}
